import {
    IMPORT_ACCOUNT_EXCEPTION_DETAILS_OPEN_MODAL,
    IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_REQUEST,
    IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_RESULT,
    IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_REQUEST,
    IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_RESULT,
} from 'Redux/actionTypes';

export const exceptionImportDetailsOpenModal = (open, account) => ({
    type: IMPORT_ACCOUNT_EXCEPTION_DETAILS_OPEN_MODAL,
    payload: { open, account }
})

export const exceptionImportSearchDetailsRequest = (data) => ({
    type: IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_REQUEST,
    payload: data
})

export const exceptionImportSearchDetailsResult = (result) => ({
    type: IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_RESULT,
    payload: result
})

export const exceptionImportGetDetailsRequest = (data) => ({
    type: IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_REQUEST,
    payload: data
})

export const exceptionImportGetDetailsResult = (data) => ({
    type: IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_RESULT,
    payload: data
})